<mat-card-content class="p-l-10" style="height:75vh" *ngIf="selectedtab!=='Prescription' && selectedtab!=='PatientReport'">
    <!-- Loading Indicator -->
    <div *ngIf="isLoadingCategories" class="d-flex justify-content-center align-items-center" style="height: 70vh;">
        <mat-progress-bar mode="indeterminate" class="w-50"></mat-progress-bar>
    </div>

    <!-- No Data Available Message -->
    <div *ngIf="!isLoadingCategories && noDataAvailable" class="no-data-container">
        <div class="d-flex flex-column align-items-center">
            <i-tabler name="info-circle" class="icon-30 text-muted"></i-tabler>
            <h4 class="f-w-600">{{ 'LABEL.NO_DATA' | translate }}</h4>
            <p class="f-w-600 mat-subtitle-1 f-s-16 m-l-10">
                <a class="addlink cursor-pointer " (click)="AddClinicalCategory()">
                    {{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.CATEGORY' | translate }}
                </a>
            </p>
        </div>
    </div>

    <!-- Category Tabs -->
    <mat-tab-group *ngIf="!isLoadingCategories && !noDataAvailable" mat-stretch-tabs="false" animationDuration="10ms"
        (selectedIndexChange)="onTabChange($event)">
        <mat-tab *ngFor="let category of listofcategory; let i = index">
            <ng-template mat-tab-label>
                {{ category.name }}
            </ng-template>
            <div class="category-scroll">
                <app-opd-category-panel [category]="category" [checkedRecords]="checkedFromBackend" [opdId]="opdID"
                    [refreshKey]="categoryRefreshKeys[category.id] || 0"
                    (subcategorySelected)="onSubcategorySelected($event)" (stateChanged)="onSubcategoryStateChanged()"
                    (contentLoaded)="onCategoryContentLoaded($event)">
                </app-opd-category-panel>
            </div>
        </mat-tab>
    </mat-tab-group>
</mat-card-content>
